var _circle, _path, _circle2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#d80027",
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m381.197 256-51.155 24.062 27.241 49.547-55.553-10.629-7.036 56.116-38.695-41.27-38.692 41.27-7.039-56.116-55.548 10.627 27.24-49.547-51.157-24.06 51.157-24.061-27.24-49.548 55.546 10.63 7.043-56.117 38.69 41.271 38.697-41.271 7.034 56.117 55.555-10.63-27.242 49.551z",
    fill: "#ffda44"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#d80027",
    r: 77.913
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffda44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m217.043 256c-1.877 0-3.73.096-5.559.278.067 10.791 3.971 20.668 10.419 28.341 3.44-9.257 8.576-17.698 15.053-24.922-6.186-2.379-12.897-3.697-19.913-3.697z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.025 297.933c4.68 1.672 9.719 2.589 14.975 2.589s10.295-.917 14.975-2.589c-2.551-10.012-7.818-18.95-14.975-25.974-7.157 7.023-12.424 15.962-14.975 25.974z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m294.555 233.746c-7.698-13.306-22.075-22.268-38.555-22.268s-30.857 8.961-38.555 22.268c14.034.071 27.194 3.887 38.555 10.476 11.361-6.589 24.519-10.405 38.555-10.476z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.042 259.698c6.477 7.223 11.613 15.664 15.053 24.922 6.448-7.673 10.352-17.55 10.419-28.341-1.83-.183-3.683-.278-5.559-.278-7.014-.001-13.725 1.317-19.913 3.697z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKg);
export default __webpack_public_path__ + "static/media/4bd96339573d5cb086716451add2736e0e991b197a.svg";
export { ForwardRef as ReactComponent };